export const SUBSCRIPTION_LICENSE = 'license'
export const SUBSCRIPTION_SUPPORT = 'support'
export const SUBSCRIPTION_CREATIVE = 'creative'

/** Matches Postgres / Stripe-style statuses from `getCampaignSubscriptions`; excludes `incomplete` (checkout abandoned). */
const SUBSCRIPTION_ENDED_STATUSES = new Set(['canceled', 'unpaid', 'incomplete_expired', 'past_due'])

export const isSubscriptionEndedStatus = (status) => {
    if (typeof status !== 'string' || !status.trim()) return false
    return SUBSCRIPTION_ENDED_STATUSES.has(status.trim().toLowerCase())
}
